import { render, staticRenderFns } from "./Custom-Table.vue?vue&type=template&id=22906586&"
import script from "./Custom-Table.vue?vue&type=script&lang=js&"
export * from "./Custom-Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22906586')) {
      api.createRecord('22906586', component.options)
    } else {
      api.reload('22906586', component.options)
    }
    module.hot.accept("./Custom-Table.vue?vue&type=template&id=22906586&", function () {
      api.rerender('22906586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Custom-Table.vue"
export default component.exports